export default {
	text: 'Text',
	select: 'Selection',
	inputValue: 'Enter value',
	checkbox: 'Checkbox',
	calendar: 'Calendar',
	user: 'User',
	tables: {
		assets: 'Assets',
		sub_assets: 'Sub assets',
		data_assets: 'Data assets',
		instances: 'Institutions',
		users: 'Users',
		standard_methods: 'Measures',
		standard_method_meta_data: 'Measure connections',
		business_processes: 'Business processes',
	},
}
